import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IoArrowForward } from "react-icons/io5";

const MainNav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Function to handle the WhatsApp redirection
  const redirectToWhatsApp = () => {
    const phoneNumber = "+256709438944"; // Replace with your desired phone number
    const message = encodeURIComponent("Hello, I need help!"); // Optional pre-filled message
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    window.open(whatsappUrl, "_blank"); // Opens WhatsApp in a new tab
  };

  return (
    <>
      <div
        data-animation="default"
        className="navbar w-nav"
        data-easing2="ease"
        data-easing="ease"
        data-collapse="medium"
        data-w-id="6999f335-005a-f68f-bf29-0723f291d072"
        role="banner"
        data-duration="400"
        id="navbar"
      >
        <nav className="container">
          <div className="navbar-wrapper">
            <a
              href="/"
              aria-current="page"
              className="site-logo-wrapper w-nav-brand w--current"
              aria-label="home"
            >
              <img
                src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232607/verticle_mocryg_azlnru.svg"
                loading="lazy"
                width="70"
                alt=""
                className="site-logo"
              />
            </a>
            <nav
              role="navigation"
              className="nav-menu-wrapper w-nav-menu"
              style={{
                transition: "all",
                transform: "translateY(0px) translateX(0px)",
              }}
            >
              <ul role="list" className="nav-menu w-list-unstyled">
                <li
                  data-w-id="4ef02e47-0ea5-5857-a6ac-bbd1e53c8b90"
                  className="nav-list"
                >
                  <Link to="/">
                    <div className="nav-icon-and-text-wrapper">
                      <a
                        href="/"
                        aria-current="page"
                        className="nav-link w--current"
                      >
                        Home
                      </a>
                    </div>
                  </Link>
                </li>
                <li
                  data-w-id="4ef02e47-0ea5-5857-a6ac-bbd1e53c8b95"
                  className="nav-list"
                >
                  <Link to="/about-us">
                    <div className="nav-icon-and-text-wrapper">
                      <a className="nav-link">About Us</a>
                    </div>
                  </Link>
                </li>
                <li
                  data-w-id="e181c60f-5c0b-67fd-79c0-b6ace79ca34d"
                  className="nav-list"
                >
                  <Link to="/services">
                    <div className="nav-icon-and-text-wrapper">
                      <a href="/services" className="nav-link">
                        Services
                      </a>
                    </div>
                  </Link>
                </li>
                <li
                  data-w-id="4ef02e47-0ea5-5857-a6ac-bbd1e53c8b9f"
                  className="nav-list"
                >
                  <Link to="/tours">
                    <div className="nav-icon-and-text-wrapper">
                      <a href="/tour" className="nav-link">
                        Tours
                      </a>
                    </div>
                  </Link>
                </li>

                <li
                  data-w-id="4ef02e47-0ea5-5857-a6ac-bbd1e53c8b9a"
                  className="nav-list"
                >
                  <Link to="/contact">
                    <div className="nav-icon-and-text-wrapper">
                      <a href="/contact" className="nav-link">
                        Contact
                      </a>
                    </div>
                  </Link>
                </li>
                <li className="nav-button-list show-in-mobile">
                  <a
                    data-w-id="d8d360e1-f645-321f-d65f-94a46da5403d"
                    href="/contact"
                    className="primary-button w-inline-block"
                  >
                    <div className="button-text-wrapper">
                      <div className="default-text">Book Now</div>
                      <div className="hover-text">Book Now</div>
                    </div>
                    <div className="icon">east</div>
                    <div className="button-hover" style={{ width: "0%" }}></div>
                  </a>
                </li>
              </ul>
            </nav>
            <div className="hide-in-tablet">
              <Link
                to="/"
                data-w-id="34cc201b-a56e-fb87-45ec-e28953536219"
                href=""
                className="primary-button w-inline-block"
              >
                <div className="button-text-wrapper">
                  <div
                    className="default-text"
                    style={{
                      transform:
                        "translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                      transformStyle: "preserve-3d",
                    }}
                    onClick={redirectToWhatsApp}
                  >
                    Book Now
                  </div>
                  <div
                    className="hover-text"
                    style={{
                      transform:
                        "translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                      transformStyle: "preserve-3d",
                    }}
                    onClick={redirectToWhatsApp}
                  >
                    Book Now
                  </div>
                </div>
                <div
                  className="button-hover"
                  style={{ width: "0%", height: "58px" }}
                ></div>
              </Link>
            </div>
            {/* MOBILE-VERSION-START */}

            <div
              className="hambruger-button w-nav-button"
              style={{
                WebkitUserSelect: "text",
              }}
              aria-label="menu"
              role="button"
              tabIndex="0"
              aria-controls="w-nav-overlay-0"
              aria-haspopup="menu"
              aria-expanded="false"
              onClick={toggleMenu}
            >
              <div className="hamburger-bars">
                <div
                  className="menu-icon_line-top"
                  style={{
                    transform:
                      "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                  }}
                ></div>
                <div
                  className="menu-icon_line-middle"
                  style={{ width: "24px", height: "2px" }}
                >
                  <div className="menu-icon_line-middle-inner"></div>
                </div>
                <div
                  className="menu-icon_line-bottom"
                  style={{
                    transform:
                      "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </nav>
        {/* MOBILE-VERSION-END */}
        {isMenuOpen && (
          <div
            className={` hambruger-button w-nav-overlay w-nav-button ${
              isMenuOpen ? "active" : ""
            }`}
            // className="w-nav-overlay"
            data-wf-ignore=""
            id="w-nav-overlay-0"
            style={{
              height: "19300.6px",
              display: "block",
            }}
          >
            <nav
              role="navigation"
              className="nav-menu-wrapper w-nav-menu"
              style={{
                transition: "all, transform 400ms",
                transform: "translateY(0px) translateX(0px)",
              }}
              data-nav-menu-open=""
            >
              <ul role="list" className="nav-menu w-list-unstyled">
                <li
                  data-w-id="4ef02e47-0ea5-5857-a6ac-bbd1e53c8b90"
                  className="nav-list"
                >
                  <Link to="/" onClick={closeMenu}>
                    <div className="nav-icon-and-text-wrapper">
                      <a aria-current="page" className="nav-link w--current">
                        Home
                      </a>
                    </div>
                  </Link>
                </li>
                <li
                  data-w-id="4ef02e47-0ea5-5857-a6ac-bbd1e53c8b95"
                  className="nav-list"
                >
                  <Link to="/about-us" onClick={closeMenu}>
                    <div className="nav-icon-and-text-wrapper">
                      <a className="nav-link">About Us</a>
                    </div>
                  </Link>
                </li>
                <li
                  data-w-id="e181c60f-5c0b-67fd-79c0-b6ace79ca34d"
                  className="nav-list"
                >
                  <Link to="/services" onClick={closeMenu}>
                    <div className="nav-icon-and-text-wrapper">
                      <a className="nav-link">Services</a>
                    </div>
                  </Link>
                </li>
                <li
                  data-w-id="4ef02e47-0ea5-5857-a6ac-bbd1e53c8b9f"
                  className="nav-list"
                >
                  <Link to="/tours" onClick={closeMenu}>
                    <div className="nav-icon-and-text-wrapper">
                      <a className="nav-link">Tours</a>
                    </div>
                  </Link>
                </li>

                <li
                  data-w-id="4ef02e47-0ea5-5857-a6ac-bbd1e53c8b9a"
                  className="nav-list"
                >
                  <Link to="/contact" onClick={closeMenu}>
                    <div className="nav-icon-and-text-wrapper">
                      <a className="nav-link">Contact</a>
                    </div>
                  </Link>
                </li>
                <li className="nav-button-list show-in-mobile">
                  <Link
                    to="/contact"
                    data-w-id="d8d360e1-f645-321f-d65f-94a46da5403d"
                    className="primary-button w-inline-block"
                  >
                    <div className="button-text-wrapper">
                      <div className="default-text">Book Now</div>
                      <div className="hover-text">Book Now</div>
                    </div>

                    <IoArrowForward />
                    <div className="button-hover" style={{ width: "0%" }}></div>
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        )}

        {/* MOBILE-VERSION-START */}
      </div>
    </>
  );
};

export default MainNav;
